import action from 'app/lib/action';
import * as actionTypes from '../constants/actionTypes';
import { getTimeSlots as getTS, getVisits as getVisitsAPI, getVisit as getVisitAPI, saveVisit } from '../repository';

import storeVisit from './storeVisit';
import deleteVisit from './deleteVisit';
import getUnits from './getUnits';
import storeUnit from './storeUnit';
import deleteUnit from './deleteUnit';
import getTimeSlots from './getTimeSlots';
import verifyUnit from './verifyUnit';
import getGoods from './getGoods';
import storeGood from './storeGood';
import deleteGood from './deleteGood';
import getDocs from './getDocs';
import storeDoc from './storeDoc';
import deleteDoc from './deleteDoc';
import submitVisit from './submitVisit';
import docsAndGoods from './docsAndGoods';
import getVisits from './getVisits';

let {VISITS, VISIT, VISIT_AND_UNITS, TIME_SLOTS, GET_VISIT} = actionTypes;

const fetchVisitSuccess = (visit) => action(GET_VISIT.SUCCESS)({visit});
const fetchVisitAndUnits = (vtrac) => action(VISIT_AND_UNITS.REQUEST)({vtrac});
const fetchVisitAndUnitsSuccess = (visit) => action(VISIT_AND_UNITS.SUCCESS)({visit});
const fetchVisitAndUnitsError = (error) => action(VISIT_AND_UNITS.ERROR)({error});
const clearLoadedVisit = () => action(VISIT_AND_UNITS.CLEAR)();

// ========================================================
//                  PUBLIC
// ========================================================


export {
    clearLoadedVisit,
    fetchVisit,
    fetchVisitSuccess,
    fetchVisitAndUnits,
    fetchVisitAndUnitsSuccess,
    fetchVisitAndUnitsError,

    getVisits,
    storeVisit,
    deleteVisit,
    submitVisit,
    getUnits,
    storeUnit,
    deleteUnit,
    getTimeSlots,
    verifyUnit,
    getGoods,
    storeGood,
    deleteGood,
    getDocs,
    storeDoc,
    deleteDoc,
    docsAndGoods
};

function fetchVisit(vtrac) {
    return {
        types: [
            VISIT.REQUEST,
            VISIT.SUCCESS,
            VISIT.ERROR
        ],
        promise: getVisitAPI(vtrac),
        appLoader: 'visit'
    };
}
